import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { backendQueryKey, useTypedQuery } from "hooks/useTypedQuery";
import { LATEST_VERSION_ENDPOINT, checkForNewAppVersion } from "utils/common";

const NEW_VERSION_TOAST_ID = "new-app-version-available";
const VERSION_CHECK_INTERVAL = 1000 * 60 * 60;

const appVersionKey = backendQueryKey<boolean>({ component: "useAppVersionCheck", baseUrl: window.location.origin, endpoint: LATEST_VERSION_ENDPOINT });

const NewVersionToastContent = () => {
  const { t } = useTranslation();

  return <span>{t("v8_new_app_version_available", "A new version is available. Click here to refresh the page.")}</span>;
};

export const useAppVersionCheck = () => {
  const { data: isNewVersionAvailable } = useTypedQuery({
    queryKey: appVersionKey,
    queryFn: checkForNewAppVersion,
    staleTime: 0,
    refetchInterval: VERSION_CHECK_INTERVAL,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true
  });

  useEffect(() => {
    if (!isNewVersionAvailable) return;

    toast.info(<NewVersionToastContent />, {
      toastId: NEW_VERSION_TOAST_ID,
      autoClose: false,
      onClick: () => document.location.reload()
    });
  }, [isNewVersionAvailable]);
};
